import * as React from 'react';
import { SocialBarIcon } from './SocialBarIcon';
import { st, classes } from './SocialBar.st.css';
import { TPAComponentsConsumer } from '../../../../esm/components/TPAComponentsConfig';
/** SocialBar */
export class SocialBar extends React.Component {
    render() {
        const { theme, children, className } = this.props;
        const childProps = { socialBarTheme: theme };
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile }) => (React.createElement("div", { className: st(classes.root, { mobile }, className), "data-hook": this.props['data-hook'] }, React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) {
                return child;
            }
            return (React.createElement("div", { className: classes.item }, React.cloneElement(child, childProps)));
        })))));
    }
}
SocialBar.Icon = SocialBarIcon;
SocialBar.displayName = 'SocialBar';
SocialBar.defaultProps = { theme: 'light' };
//# sourceMappingURL=SocialBar.js.map